import React from "react";
import LinksContainer from "./LinksContainer";

function NavBar({ active }) {
  const Landing = "#";
  return (
    <nav className="navbar navbar-expand-md shadow-sm p-3 px-2  sticky-top ">
      <div className="container-fluid ">
        <a className="navbar-brand special-hover-color" href={Landing}>
          Dalee.dev
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <LinksContainer active={active} />
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
